import React from 'react';
import SubpageHero from '../components/SubpageHero';
import TreatmentZones from '../components/TreatmentZones';
import { useBehandelzonesHero } from '../hooks/useBehandelzonesHero';

const Behandelzones: React.FC = () => {
  const { data, loading, error } = useBehandelzonesHero();

  if (loading) {
    return (
      <div style={{ 
        height: '100vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        fontSize: '18px'
      }}>
        Loading behandelzones page...
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ 
        height: '100vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        color: 'red',
        fontSize: '18px'
      }}>
        Error: {error}
      </div>
    );
  }

  // If no data is available, show a default hero
  if (!data) {
    return (
      <div>
        <div className="fallback-hero" style={{
          height: '560px',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'flex-start',
          padding: '0 120px 80px 120px'
        }}>
          <h1 style={{
            fontFamily: 'var(--h1-font-family)',
            fontWeight: 'var(--h1-font-weight)',
            fontStyle: 'var(--h1-font-style)',
            fontSize: 'var(--h1-font-size)',
            lineHeight: 'var(--h1-line-height)',
            letterSpacing: 'var(--h1-letter-spacing)',
            color: 'white',
            margin: '0'
          }}>
            Behandelzones
          </h1>
        </div>
        
        <TreatmentZones />
      </div>
    );
  }

  // Support both Strapi response shapes (with or without attributes)
  const raw = (data as any) || {};
  const attributes = raw.attributes ? raw.attributes : raw;

  // Resolve background media from different shapes
  const bgFromBackgroundMedia = attributes.backgroundMedia?.data?.attributes;
  const bgFromBackgroundImageData = attributes.backgroundImage?.data?.attributes;
  const bgFromBackgroundImage = attributes.backgroundImage;
  const bg = bgFromBackgroundMedia || bgFromBackgroundImageData || bgFromBackgroundImage;

  const backgroundMedia = bg
    ? {
        url: bg.url,
        alternativeText: bg.alternativeText,
      }
    : undefined;

  // Map text color if schema uses 'dark' instead of 'black'
  const mappedTextColor = attributes.textColor === 'dark' ? 'black' : attributes.textColor;

  return (
    <div>
      <SubpageHero
        title={attributes.title || 'Behandelzones'}
        backgroundMedia={backgroundMedia}
        mediaType={attributes.mediaType || 'image'}
        videoUrl={attributes.videoUrl}
        overlayOpacity={attributes.overlayOpacity}
        textColor={mappedTextColor}
        paddingBottom={attributes.paddingBottom}
        paddingLeft={attributes.paddingLeft}
        paddingRight={attributes.paddingRight}
      />
      
      <TreatmentZones />
    </div>
  );
};

export default Behandelzones; 